import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { GetMapSingleResponse, OwnedTargetInfo } from 'ais-facade-api/api';

import { RootState } from '../store/store';
import { BASE_URL } from 'app/utils/utils';
import i18next from 'i18next';
import { onQueryStartedErrorToast } from './apiErrorHandler';


export interface GetMapSingleResponseI extends GetMapSingleResponse {
    'result'?: OwnedTargetInfo & { inAreas: any };
}

export const shipsApi = createApi({
  reducerPath: 'ships',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL + '/facade/versions/1/',
    credentials: 'include',
    mode: 'cors',
    prepareHeaders: (headers: Headers, { getState }) => {
      const userInfo = (getState() as RootState).userSlice;
      headers.set('Accept-Language', i18next.resolvedLanguage ? i18next.resolvedLanguage : 'ru');
      if (userInfo.auth && userInfo.user) {
        headers.set('x-ais-user-csrf', userInfo.auth.value.csrfToken);
        headers.set('ais-user-csrf', userInfo.auth.value.csrfToken);
      }
      return headers;
    },
  }),
  tagTypes: ['Ships'],
  endpoints: (build) => ({
    getShipInfo: build.query<GetMapSingleResponseI, number>({
      query: (mmsi) => ({
        url: `map/${mmsi}`,
      }),
      onQueryStarted: onQueryStartedErrorToast,
      transformResponse: (response: GetMapSingleResponseI) => {
        return response;
      },
      providesTags: [{ type: 'Ships' }],
    }),

    exportFleet: build.query({
      query: () => ({
        url: 'fleet/export/csv',
        responseType: 'blob',
        overrideExisting: false,
        withCredentials: true,
        responseHandler: async (response) => {
          const blobFile = await response.blob();
          const filename = `${response.headers.get('Content-Disposition')?.split('filename=')[1]}` || 'fleet.xlsx';
          const url = window.URL.createObjectURL(new Blob([blobFile]));
          return {
            url,
            filename,
          };
        },
      }),
      onQueryStarted: onQueryStartedErrorToast,
    }),
  }),
});

export const { useGetShipInfoQuery, useLazyGetShipInfoQuery, useLazyExportFleetQuery } = shipsApi;
